import React from 'react';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import Layout from '@shared/ui/organisms/layout/Layout';
import { useTranslation } from 'react-i18next';
import './account-deleted-page.scss';

export default function AccountDeletedPage() {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className="accountDeletedPage">
        <HeadlineLarge>{t('account-deleted-page.title')}</HeadlineLarge>
        <BodyRegular>{t('account-deleted-page.description')}</BodyRegular>
        <img src="/assets/images/woman-on-laptop.svg" alt="Account deleted" />
      </div>
    </Layout>
  );
}
